import React, { useEffect, useState } from "react";
import { Tooltip } from 'reactstrap';
import moment from 'moment-timezone';

import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';

import { responseMediaApi, selectAllMediaByResponseId } from '../../reducers/responseMediaSlice';
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";

const ResponseListItem = ({surveyId, response}) => {

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [showCarousel, setShowCarousel] = useState(false);
    const media = useSelector((state) => selectAllMediaByResponseId(state, response.id))

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(responseMediaApi.fetchAll({page: 0, surveyId: surveyId, responseId: response.id}))
    }, [dispatch, surveyId, response])

    const toggle = () => setTooltipOpen(!tooltipOpen);

    const getScoreLabel = (score) => {
        let label = ""

        switch(score) {
            case 0: label = "Non valutabile (0)"; break;
            case 1: label = "Non adeguato (1)"; break;
            case 2: label = "Adeguato (2)"; break;
            case 3: label = "Buono (3)"; break;
            default:
                label = score
        }
        return label
    }

    const getAlertClassName = (score) => {
        let className = "alert "
        
        if(score == 0) className += "alert-light"
        else if(score == 1) className += "alert-danger"
        else if(score > 1 && score <= 2) className += "alert-warning"
        else if(score > 2 && score <= 3) className += "alert-success"
        
        return className
    }

    const getNoteStyle = (response) => {
        let style = {}
        if(response.note === null) style = {color: '#d2d2d2'}
        // else style = {cursor: 'pointer'}

        return style
    }

    const getAttachmentStyle = (media) => {
        let style = {}
        if(media.length === 0) style = {color: '#d2d2d2'}
        else style = {cursor: 'pointer'}

        return style
    }

    const formatDate = (dateString) => {
        let desiredFormat = "YYYY-MM-DD HH:mm:ss";
        let timeToBeConverted = moment(dateString, desiredFormat);
        let timeZone = "Europe/Rome";

        return timeToBeConverted.tz(timeZone).format(desiredFormat);
    }

    const images = media.map((media) => ({
        src: media.resource.high
    }));
    
    return (
        <>
            <tr>
                <td>
                    <span style={{display: 'block'}}><i>{ response.question.body }</i></span>
                    {response.body !== null 
                        ? <span style={{display: 'block'}}>{ response.note }</span>
                        : <></>
                    }
                    <span>
                        <span id={"note-" + response.id} className="fas fa-file-alt" style={getNoteStyle(response)} ></span>
                        <span className="m-2">|</span>
                        <span 
                            onClick={() => setShowCarousel(!showCarousel)} 
                            style={getAttachmentStyle(media)}
                        >
                            <span className="fas fa-paperclip"></span> &nbsp; 
                            { media.length > 0 ? media.length : null }
                        </span>
                    </span>
                </td>
                <td style={{whiteSpace: 'nowrap'}}>
                    { formatDate(response.created_at) }
                </td>
                <td style={{whiteSpace: 'nowrap'}}>
                    <span className={getAlertClassName(response.score)}>{ getScoreLabel(response.score) }</span>
                </td>
            </tr>
            { 
                showCarousel 
                    ? <tr>
                        <td colSpan={2}>
                            <Carousel images={images} canAutoPlay={false} style={{ height: 500, width: 800 }} />
                        </td>
                    </tr>
                    : null
            }
        </>
    )
}

export default ResponseListItem;

